
export async function setup() {

  const logoData = []
  //Default English


  logoData['XL'] = require("../assets/logo.png")
  logoData['sit'] = require("../assets/schwarz.png")
  logoData['directline'] = require("../assets/directline.png")


  return logoData

}



